export interface YouTubeAPILoadedEvent {
  target: typeof window.YT;
}

let isYouTubeAPILoaded = false;
let isYouTubeAPILoading = false;
const loadPromiseResolvers: Array<(value: boolean) => void> = [];

export const isYouTubeAPIAvailable = (): boolean => {
  return !!(window.YT && window.YT.Player && window.YT.PlayerState);
};

export const waitForYouTubeAPI = (): Promise<boolean> => {
  return new Promise((resolve) => {
    if (isYouTubeAPILoaded || isYouTubeAPIAvailable()) {
      resolve(true);
      return;
    }

    loadPromiseResolvers.push(resolve);

    if (!isYouTubeAPILoading) {
      isYouTubeAPILoading = true;

      (window as any).onYouTubeIframeAPIReady = () => {
        console.log('🎵 YouTube IFrame API Ready');
        isYouTubeAPILoaded = true;
        isYouTubeAPILoading = false;

        loadPromiseResolvers.forEach(resolver => resolver(true));
        loadPromiseResolvers.length = 0;
      };

      const existingScript = document.querySelector('script[src*="youtube.com/iframe_api"]');
      if (!existingScript) {
        console.log('🎵 Loading YouTube IFrame API script...');
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        document.head.appendChild(script);
      }

      setTimeout(() => {
        if (!isYouTubeAPILoaded) {
          console.warn('⚠️ YouTube API failed to load within timeout');
          isYouTubeAPILoading = false;
          loadPromiseResolvers.forEach(resolver => resolver(false));
          loadPromiseResolvers.length = 0;
        }
      }, 10000);
    }
  });
};

export const getYouTubePlayerState = () => {
  if (isYouTubeAPIAvailable()) {
    return window.YT!.PlayerState;
  }

  return {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
  };
};

export const initializeYouTubeAPI = () => {
  if (typeof window !== 'undefined') {
    waitForYouTubeAPI();
  }
};
